(function () {
  // Helper function to format money with Colombian format (dots as thousands separator)
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      var format = window.themeHDN?.settings?.moneyFormat || window.theme?.moneyFormat || '${{amount}}';
      var formatted = Shopify.formatMoney(cents, format);
      
      // Force Colombian format: replace commas with dots for thousands separator
      // This handles formats like 1,234,567.00 -> 1.234.567.00
      // First, temporarily replace decimal separator if exists
      if (formatted.indexOf('.') !== -1 && formatted.lastIndexOf('.') > formatted.length - 4) {
        // Has decimal separator (e.g., 1,234.00)
        var parts = formatted.split(/(\d+[.,]\d{2}$)/);
        if (parts.length > 1) {
          parts[0] = parts[0].replace(/,/g, '.');
          return parts.join('');
        }
      }
      // No decimal separator, just replace commas with dots
      return formatted.replace(/,/g, '.');
    }
    // Fallback formatting with dots
    var amount = (cents / 100).toFixed(0);
    return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches('hdt-variant-picker.hdt-card-variant-picker input[type="radio"]')) return;

    var card = input.closest('hdt-card-product');
    if (!card) return;

    // Update image
    var vimg = input.getAttribute('data-vimg');
    if (vimg) {
      var mainImg = card.querySelector('.hdt-card-product__media--main');
      if (mainImg) {
        var newImg = mainImg.cloneNode(false);
        newImg.src = vimg;
        newImg.removeAttribute('srcset');
        newImg.removeAttribute('data-widths');
        newImg.removeAttribute('sizes');

        mainImg.parentElement.removeAttribute('loaded');
        mainImg.replaceWith(newImg);
      }
    }

    // Update price
    var variantId = input.getAttribute('data-vid');
    if (!variantId) return;

    var variantsData = card.getAttribute('data-variants');
    if (!variantsData) return;

    try {
      var variants = JSON.parse(variantsData);
      var selectedVariant = variants.find(function(v) { return v.id == variantId; });
      
      if (!selectedVariant) return;

      // Update main price
      var priceElement = card.querySelector('hdt-price .hdt-money');
      if (priceElement) {
        priceElement.textContent = formatMoney(selectedVariant.price);
      }

      // Update compare at price
      var compareAtPriceWrapper = card.querySelector('hdt-compare-at-price');
      if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
        if (!compareAtPriceWrapper) {
          // Create compare at price element if it doesn't exist
          var priceList = card.querySelector('.hdt-price__list');
          if (priceList) {
            compareAtPriceWrapper = document.createElement('hdt-compare-at-price');
            compareAtPriceWrapper.className = 'hdt-compare-at-price';
            compareAtPriceWrapper.innerHTML = '<span class="sr-only sr-only--inline">Regular price</span><span class="hdt-money"></span>';
            priceList.insertBefore(compareAtPriceWrapper, priceList.firstChild);
          }
        }
        if (compareAtPriceWrapper) {
          var compareMoneyElement = compareAtPriceWrapper.querySelector('.hdt-money');
          if (compareMoneyElement) {
            compareMoneyElement.textContent = formatMoney(selectedVariant.compare_at_price);
          }
          compareAtPriceWrapper.style.display = '';
        }
      } else if (compareAtPriceWrapper) {
        // Hide compare at price if not applicable
        compareAtPriceWrapper.style.display = 'none';
      }
    } catch (err) {
      console.error('Error updating card price:', err);
    }
  });
})();
